/**
 * localeUtils.js
 * This utility file provides a reliable, synchronous way to get date-fns locale objects.
 */
import { enUS, enGB, fr, es, de, ja, ko, ru } from 'date-fns/locale'; // Add any other locales you need here

// Create a static map from language strings to the imported locale objects.
// This is the most reliable method and avoids bundler issues with dynamic imports.
const localeMap = {
  'en-US': enUS,
  'en-GB': enGB,
  'en': enGB,
  'fr': fr,
  'es': es,
  'de': de,
  'ja': ja,
  'ko': ko,
  'ru': ru,
};

/**
 * Synchronously retrieves a date-fns locale object based on a language string.
 * @param {string} localeString - The language identifier (e.g., 'fr', 'es', 'en-US').
 * @returns {object} The date-fns locale object. Falls back to en-US if not found.
 */
export const getLocaleObject = (localeString) => {
  // Look up the locale in the map.
  // The || enUS provides a safe fallback if the key doesn't exist.
  return localeMap[localeString] || fr;
};
